import React, {Component} from "react";
import YearFilter from "../../../../Filters/EventStats/CompareStats/YearFilter";
import MonthFilter
  from "../../../../Filters/EventStats/CompareStats/MonthFilter";
import RegistrationCAFilter
  from "../../../../Filters/EventStats/EventRegistrantLinechart/RegistrationCAFilter";
import TypeFormatFilter from "../../../../Filters/EventStats/EventRegistrantLinechart/TypeFormatFilter";

export default class CompareStatsFilters extends Component {

  render() {
    const {
      startMonth,
      endMonth,
      handleStartMonthChange,
      handleEndMonthChange,
      year,
      handleYearChange,
      updateChartType,
      updateLegendType,
      type,
      legendType,
      frequency,
    } = this.props;

    return (
      <div className={'flex items-center'} style={{gap: '2%'}} >
        <div style={{width: '50%'}}>
          <TypeFormatFilter legendType={legendType} updateLegendType={updateLegendType}/>
        </div>
        <div className={'compare-stats-filters'} style={{width: '50%', justifyContent: 'flex-end'}}>
          <div className={'flex items-center mr-2'}>
            <YearFilter year={year} handleYearChange={handleYearChange}/>
          </div>
          {
            frequency === 'MONTHLY' &&
            <MonthFilter 
              startMonth={startMonth} 
              endMonth={endMonth}
              handleStartMonthChange={handleStartMonthChange}
              handleEndMonthChange={handleEndMonthChange}
            />
          }
        </div>
      </div>
    );
  }
}






// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/CompareStats/CompareStatsFilters.js